import { BrowserRouter as Router } from "react-router-dom";
import MainComponent from "./components/main-layout";
import AuthProvider from "./providers/auth-provider";

function App() {
  return (
    <Router>
      <AuthProvider>
        <MainComponent />
      </AuthProvider>
    </Router>
  );
}

export default App;
